// LeadIQ's verdict on a value, in the extension's vocabulary: one glyph before the value and a tooltip.
// A tooltip states only what Raven's own data says; it never infers why upstream decided it.
export type MarkDataType = 'email' | 'phone'
export type Glyph = 'check_filled' | 'check_outlined' | 'question' | 'cross' | 'warning'
export type VerificationMarkSpec = { glyph: Glyph; label: string }

export const VERIFICATION_MARKS: Record<MarkDataType, Record<string, VerificationMarkSpec>> = {
  email: {
    verified: { glyph: 'check_filled', label: 'Verified email' },
    verified_likely: { glyph: 'check_outlined', label: 'Verified likely' },
    unverified: { glyph: 'question', label: 'Unverified' },
    invalid: { glyph: 'cross', label: 'Invalid' },
    suppressed: { glyph: 'cross', label: 'Suppressed by LeadIQ' },
    person_not_found: { glyph: 'question', label: 'Not found in LeadIQ' },
    no_longer_current: { glyph: 'question', label: 'Found under a past position in LeadIQ' },
    different_email: { glyph: 'question', label: 'LeadIQ has a different email for this person' },
  },
  // An unverified mobile is just a mobile: no glyph, as in the extension.
  phone: {
    verified_likely: { glyph: 'check_filled', label: 'Likely to be accurate' },
    verified: { glyph: 'check_filled', label: 'Verified' },
    invalid: { glyph: 'cross', label: 'Invalid' },
    suppressed: { glyph: 'warning', label: 'Suppressed by LeadIQ' },
  },
}

export function verificationMark(dataType: string | null | undefined, status: string | null | undefined): VerificationMarkSpec | null {
  if (!dataType || !status) return null
  return VERIFICATION_MARKS[dataType as MarkDataType]?.[status] ?? null
}

// LeadIQ is the product; only another origin is worth pointing out.
export function showsProvenanceMarker(provider: string | null | undefined): boolean {
  return !!provider && provider !== 'leadiq'
}
